exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-notification[data-v-7efdd665]{margin-left:0}.border-outline[data-v-7efdd665]{border:1px solid #c4c7ca;padding:15px;margin:1px;color:#414953}.border-text[data-v-7efdd665]{margin-top:-28px;background:#fff;position:absolute}", ""]);

// exports
